(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/views/best-rows.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/views/best-rows.js'); 'use strict';

svs.sport.best_rows.views.BestRows = Marionette.View.extend({
  template: function template(data) {
    return svs.sport.best_rows.templates.best_rows(data);
  },
  templateContext: function templateContext() {
    return {
      mode: this.options.mode,
      productName: svs.sport.best_rows.models.wager.productName.toLowerCase(),
      isMSYSSROW: svs.sport.best_rows.models.wager.systemType === 'MSYS' || svs.sport.best_rows.models.wager.systemType === 'SROW'
    };
  },
  className: 'panel panel-default grid-row',
  regions: {
    bestRowsMatches: '#best-rows-matches',
    bestRowsRows: '#best-rows-rows'
  },
  ui: {
    modeButtons: '.js-best-rows-mode'
  },
  events: {
    'click @ui.modeButtons': 'onChangeMode'
  },
  onRender: function onRender() {
    this.model.get('matchList').setMode({
      mode: this.options.mode || 'matcher'
    });
    this.showChildView('bestRowsMatches', new svs.sport.best_rows.views.BestRowsMatches({
      collection: this.model.get('matchList'),
      model: this.model
    }));
    this.showChildView('bestRowsRows', new svs.sport.best_rows.views.BestRowsList({
      collection: this.model.get('rowsCollection')
    }));
  },
  onChangeMode: function onChangeMode(e) {
    svs.components.analytics.trackEvent({
      category: 'Liverattning',
      action: e.currentTarget.value,
      label: svs.sport.best_rows.models.wager.productName
    });
    this.model.get('matchList').setMode({
      mode: e.currentTarget.value
    });
  },
  onAttach: function onAttach() {
    svs.components.swiper.init(this.regions.bestRowsRows, {
      scrollbars: true,
      scrollingX: true,
      alwaysScroll: false,
      scrollingY: false
    });
  }
});
 })(window);